module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAEnSURBVEiJtdWxSgNBEAbgf84rBBtBTN5BU6SImPJsrQQTLg+RyIqNjWRAxDIBH0JFFFKmEJJS09iktxbTWpkdq8CJYG5mL3+1O7vDB1PsAspwu1Xjdqum7Ys0ly86qfMkE08y6Z6k1yuDCHS2WIvgvNtJeyuBAD/I7gRweTEVFG19OIg8WrA1DTQavfuDw+0n+drYBdFO5qie7Fc2x6/TYSFQCKaGrJgJsmBmSIsFQRosGFqK1Svr45fpMxUBLcKcxP6zdAei42w9EtpTvgzLIwT5U4zn34VBzEk8n5VuCdT4BQOn3H94K2R0/yGXN/d9AAiG8iDBUF4kCNIgZkiLmCALooasCADEGkhm5R4BagRQfuUCOrIgekj8lQUxhV2zyq5Z1fb9AGAbyfQUG9uLAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/m5.png
// module id = bVLx
// module chunks = 1